import { INSURANCE } from "@/lib/site";
import { ShieldCheck } from "lucide-react";

export default function AcceptedInsurance() {
  return (
    <div data-testid="accepted-insurance" className="text-center">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary/30 bg-primary/5 text-primary text-xs font-medium mb-4">
        <ShieldCheck className="w-3.5 h-3.5" />
        Insurance accepted
      </div>
      <h3 className="font-display text-3xl md:text-4xl tracking-tight mb-3">
        Insurance accepted
      </h3>
      <p className="text-muted-foreground max-w-xl mx-auto mb-8">
        Plan not listed? Reach out — we&rsquo;ll check your benefits.
      </p>

      {/* Mobile: continuous marquee · Desktop: 4-col grid */}
      <div className="relative -mx-4 sm:mx-0 md:hidden overflow-hidden mask-fade">
        <div className="flex gap-4 w-max animate-marquee py-1 px-4">
          {[...INSURANCE, ...INSURANCE].map((i, idx) => (
            <div
              key={`${i.name}-${idx}`}
              className="h-24 w-40 shrink-0 rounded-2xl border border-border/70 bg-card flex items-center justify-center px-5"
              aria-hidden={idx >= INSURANCE.length || undefined}
            >
              <img
                src={i.logo}
                alt={idx < INSURANCE.length ? i.name : ""}
                className="max-h-14 max-w-[80%] object-contain"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="hidden md:grid grid-cols-2 sm:grid-cols-4 gap-4">
        {INSURANCE.map((i) => (
          <div
            key={i.name}
            data-testid={`insurance-${i.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="group relative h-28 md:h-32 rounded-2xl border border-border/70 bg-card flex items-center justify-center px-5 transition-all hover:border-primary/40 hover:shadow-[0_18px_40px_-22px_hsl(var(--primary)/0.3)] hover:-translate-y-0.5"
          >
            <img
              src={i.logo}
              alt={i.name}
              className="max-h-16 md:max-h-20 max-w-[88%] object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
